class BackpackViewModel {
  id;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  marketing_code;
  serial_number;
  uid;
  used_at;
  value;
  currency;
  tool_label;
}
export {
  BackpackViewModel
};
//# sourceMappingURL=types.js.map
